export default "/images/e9901ac461058f86b162334777779a47.avif";